import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/common.less';
import apis from '@/api/index'
import water2 from 'vue-waterfall2'
import { message } from "@/utils/message"
const isMd = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
import ElementUI from 'element-ui';
import svgIcon from '@/assets/index'
import { openWindow } from '@/utils/tools'
require('@/assets/css/theme/index.css')
if (isMd) {
  require('@/assets/css/md.css');
} else {
  // import 'element-ui/lib/theme-chalk/index.css';
  require('@/assets/css/pc.css');
}
Vue.config.productionTip = false

Vue.prototype.$request = apis
Vue.prototype.$openWindow = openWindow
Vue.use(water2)
Vue.use(ElementUI)
Vue.prototype.$message = message
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
